export default {
      id: "arrow-down-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }